export const TEAMS_FIELD_NAME = 'teams';
